/**
 * @generated SignedSource<<9d23eaab681e50b66240f9aef9825769>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutPaymentStepSubmit_buyer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutBankAccountsSubmitStripe_buyer" | "CheckoutBankAccountsSubmit_buyer" | "CheckoutCreditCardSubmit_buyer" | "CheckoutPayPalSubmit_buyer" | "CheckoutWireTransferSubmit_buyer">;
  readonly " $fragmentType": "CheckoutPaymentStepSubmit_buyer";
};
export type CheckoutPaymentStepSubmit_buyer$key = {
  readonly " $data"?: CheckoutPaymentStepSubmit_buyer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutPaymentStepSubmit_buyer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutPaymentStepSubmit_buyer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutCreditCardSubmit_buyer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutWireTransferSubmit_buyer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutPayPalSubmit_buyer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutBankAccountsSubmit_buyer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutBankAccountsSubmitStripe_buyer"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "d0e2231f835d06116b53456adb21f15b";

export default node;
